import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeContextProvider } from '../../contexts/ThemeContext';

const ThemeLayout = () => {
  return (
    <ThemeContextProvider>
      <Outlet />
    </ThemeContextProvider>
  );
};

export default ThemeLayout;
